import { connect } from 'react-redux';
import { withLastLocation } from 'react-router-dom-last-location';
import Advisor from './advisor';
import { loadAdvisor, getSimilarOnlineAdvisors } from '../../actions/advisors';
import { trackBEvent } from '../../actions/b_events';
import { startChat } from '../../actions/chat';
import { initVoipChat } from '../../actions/voip_chat';
import { displayNotifyMe } from '../../actions/notify_me';
import { authPendingAction, displayRegister } from '../../actions/auth';
import withPGTranslation from '../../config/withPGTranslation';
import { matchPaths } from '../../../common/config/utils';
import { getAdvisorDataIfSsrMode } from '../../config/util';

const mapStateToProps = (
  {
    advisors, applicationError, user: { loading: userLoading, user }
  },
  ownProps
) => {
  const { match } = ownProps;
  const { pathname } = match;
  const knownPaths = ((advisors || {}).knownPaths || {});
  const matchPathname = matchPaths({ pathname: Object.keys(knownPaths), path: pathname });
  const id = knownPaths[matchPathname?.pattern?.path];
  const advisor = (advisors || {})[id];
  return {
    ...(advisor || {}),
    ...applicationError,
    advisorLoaded: !!advisor,
    userId: user && user.id,
    userLoading,
    loading: advisors.loading && !getAdvisorDataIfSsrMode()
  };
};

export default connect(
  mapStateToProps,
  {
    loadAdvisor,
    startChat,
    initVoipChat,
    displayNotifyMe,
    authPendingAction,
    displayRegister,
    trackBEvent,
    getSimilarOnlineAdvisors
  }
)(withLastLocation(withPGTranslation(Advisor)));
